/**
 * File awards-and-certifications.js.
 *
 * Handles awards list blocks.
 */
(function ($) {
    'use strict';
    
    $(document).ready(function () {
        // Load more awards
        $(document).on('click', '.awards-and-certifications-list .awards-list-read-more-btn-action', function () {
            let paged = $(this).attr('data-page') ? parseInt($(this).attr('data-page')) + 1 : 1;
            let awardsPerPage = $(this).attr('data-awards-per-page') ? parseInt($(this).attr('data-awards-per-page')) : 5;
            let categories = $(this).attr('data-categories') ? $(this).attr('data-categories') : '';
            let filterItem = $(this).parents(".awards-and-certifications-list");
            awardsListAjax(filterItem, paged, awardsPerPage, categories, false);
        });
    }); 

    // Ajax For awards List Block
    function awardsListAjax(filterItem, paged, awardsPerPage, categories, scrollInView = true) {
        filterItem.find('.awards-and-certifications-list__row').addClass('awards-and-certifications-list__loading');
        jQuery.ajax({
            type: 'POST',
            dataType: "json",
            data: {
                action: "efi_awards_list",
                awards_per_page: awardsPerPage,
                ajax_nonce: siteConfig.ajax_nonce,
                paged: paged,
                categories: categories,
            },
            url: siteConfig.ajaxUrl,
            success: function (awardsData) {
                let awardsObj = awardsData.data.result_awards;

                if ( awardsObj && 0 < awardsObj.length ) {

                    $.each( awardsObj, function ( key, item ) {
                        let awardsItem = document.createElement('div');
                        awardsItem.setAttribute('class', 'awards-and-certifications-list__item');

                        let imgSection = document.createElement('div');
                        imgSection.setAttribute('class', 'awards-and-certifications-list__img');

                        let awardImg = document.createElement('img');
                        awardImg.setAttribute('src', item.award_img);
                        awardImg.setAttribute('alt', item.title);

                        let awardUrl = document.createElement('a');
                        awardUrl.setAttribute('href', item.award_url);
                        awardUrl.setAttribute('target', '_blank');

                        awardUrl.appendChild( awardImg );
                        imgSection.appendChild( awardUrl );

                        let contentSection = document.createElement('div');
                        contentSection.setAttribute('class', 'awards-and-certifications-list__content');

                        let awardTitle = document.createElement('h2');
                        awardTitle.setAttribute('class', 'awards-and-certifications-list__title');
                        awardTitle.innerHTML = item.title;

                        let titleUrl = document.createElement('a');
                        titleUrl.setAttribute('href', item.award_url);
                        titleUrl.setAttribute('target', '_blank');

                        titleUrl.appendChild( awardTitle );

                        let descSection = document.createElement('div');
                        descSection.setAttribute('class', 'awards-and-certifications-list__desc');
                        descSection.innerHTML = item.descriptions;

                        let metaSection = document.createElement('div');
                        metaSection.setAttribute('class', 'awards-and-certifications-list__meta');

                        let metaPSection = document.createElement('p');
                        metaPSection.innerText = item.award_date;

                        metaSection.appendChild( metaPSection );

                        contentSection.appendChild( titleUrl );
                        contentSection.appendChild( descSection );
                        contentSection.appendChild( metaSection );

                        awardsItem.appendChild(imgSection);
                        awardsItem.appendChild(contentSection);
                        filterItem.find( '.awards-and-certifications-list__row' ).append( awardsItem );
                    })

                }

                let maxPages = awardsData.data.max_pages;
                let items = filterItem.find('.awards-and-certifications-list__row')[0];
                let loadMoreObj = filterItem.find('.awards-list-read-more-btn-action');
                if (items && 1 === paged) {
                    while (items.firstChild) {
                        items.removeChild(items.firstChild);
                    }
                }

                loadMoreObj.attr('data-max-page', maxPages);
                loadMoreObj.attr('data-page', paged);
                if (maxPages > paged) {
                    loadMoreObj.show();
                } else {
                    loadMoreObj.hide();
                }

                if (scrollInView) {
                    filterItem[0].scrollIntoView({behavior: 'smooth', block: "end", inline: 'nearest'});
                }
                filterItem.find('.awards-and-certifications-list__row').removeClass('awards-and-certifications-list__loading');
            }
        });
    }
})(jQuery);